import { Routes, Route } from 'react-router-dom';
import SupportPage from './pages/SupportPage';

export default function App() {
  return (
    <Routes>
      <Route path="/*" element={<SupportPage />} />
    </Routes>
  );
}
